<div [formGroup]="parentForm">
  <div class="flex flex-col gap-2">
    <div class="text-lg font-medium">CA #:</div>
    <mat-form-field appearance="fill" class="w-full">
      <mat-label>CA Number</mat-label>
      <input
        matInput
        formControlName="caCustomDescription"
        readonly
        placeholder="No CA Number assigned"
        class="cursor-default"
      />
    </mat-form-field>
    <div class="flex gap-4 mt-4" *ngIf="!viewDisable">
      <button
        mat-flat-button
        class="text-white font-semibold shadow-md"
        [disabled]="readonly"
        (click)="openCreateCaModal()"
      >
        CREATE NEW CA# +
      </button>
      <button
        mat-flat-button
        [disabled]="readonly"
        class="text-white font-semibold shadow-md"
        (click)="openAddToCaModal()"
      >
        ADD TO CA#
      </button>
    </div>
  </div>

  <div class="grid grid-cols-1 md:grid-cols-2 gap-8 mt-8"
       *ngIf="!viewDisable"
  >
    <mat-form-field appearance="fill" class="w-full">
      <mat-label>Client Part #</mat-label>
      <input matInput
             formControlName="clientPartNo"
             class="cursor-default">
    </mat-form-field>

    <mat-form-field appearance="fill" class="w-full">
      <mat-label>Feet Per Reel</mat-label>
      <input matInput
             formControlName="feetPerReel"
             class="cursor-default">
    </mat-form-field>
  </div>
</div>
